import { Colors } from "src/styles/DesignSystem";
import styled from "styled-components";


export const BannerSection = styled.section`
    width: 100%;
    position: relative;
    margin-bottom: 25%;

    display: flex;
`;

export const Background = styled.img`
    width: 100%;
    position: absolute;
    z-index: -2;

    margin: 5% 0 0 -10%;

    @media screen and (min-width: 320px) and (max-width: 480px){
        bottom: 0;
    }
`;

export const BannerContent = styled.aside`
    width: 35%;
    margin: 5% 0 0 12%;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
   

    p{
        margin: 1.25rem 0;
        font: 1rem/1.2 'Varela Round',arial,sans-serif;
        color: ${Colors.grey };
    }

    footer{
        
        display: flex;
        align-items: center;

        a{
            margin-left: 15px;
            font: 1rem/1 'Varela Round',arial,sans-serif;
            color: ${Colors.orange };
            overflow: hidden;
        }
    }

    @media screen and (min-width: 320px) and (max-width: 480px){
        flex: 1;
        width: 100%;

        margin: 0 5%;
    }

`;

export const BannerImage = styled.figure`
    position: absolute;
    z-index: -1;
    top: 0;
    right: 0;
    margin-top: -12%;
    width: 65%;

    img{
        width: 100%;
    }

    @media screen and (min-width: 320px) and (max-width: 480px){
        flex: 2;
        width:100%;
        margin: 45% 0 0 0;
    }
`;